import React from "react";
import { cl } from "../helpers/general";
import { GRADIENT_1 } from "../styles";
import { GatsbyLinkProps, Link } from "gatsby";

interface Props extends GatsbyLinkProps<any> {
  label: string;
  bgColor?: string;
}

export const OutlineLink = (props: Props) => {
  return (
    <Link
      to={props.to}
      className={cl(
        "rounded-full overflow-hidden p-[1px] inline-block",
        GRADIENT_1
      )}
    >
      <div className={cl("rounded-full", props.bgColor || "bg-brand-six")}>
        <div
          className={cl(
            "text-transparent font-bold bg-clip-text px-10 py-4",
            GRADIENT_1
          )}
        >
          {props.label}
        </div>
      </div>
    </Link>
  );
};
